export enum PX_CUSTOM_CHART_PLUGINS {
  FAT_ARROW = "fatArrow",
}
